import { render, staticRenderFns } from "./MioClassVisits.vue?vue&type=template&id=54a4d6ae&"
import script from "./MioClassVisits.vue?vue&type=script&lang=js&"
export * from "./MioClassVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports